import React, { Component } from 'react';
import './NoEligibleAccounts.scss';
import { STEP_LINK_BANK } from '../AddBank/AddBank';
import Button from '../../../components/Shared/Button/Button';

export class NoEligibleAccounts extends Component {
  constructor(props) {
    super(props);
    this.setBankProgressHandler = this.setBankProgressHandler.bind(this);
  }

  componentDidMount() {
    const { dispatchPageLoad } = this.props;
    dispatchPageLoad('BANK_SELECTION_NO_ELIGIBLE');
  }

  setBankProgressHandler() {
    const { setBankProgress } = this.props;
    setBankProgress(STEP_LINK_BANK);
  }

  render() {
    return (
      <div className="no-eligible-accts">
        <div className="no-eligible-header">
          You successfully logged in, but this <br />
          institution has no eligible accounts.
        </div>
        <div className="no-eligible-dash" />
        <div className="no-eligible-subhead">
          To continue, choose another bank with an
          <br />
          active checking or savings account.
        </div>
        <div className="no-eligible-actions-container">
          <Button
            buttonType="primary-large"
            className="btn-trp-primary-large "
            onClick={this.setBankProgressHandler}
          >
            Choose Another Bank
          </Button>
        </div>
      </div>
    );
  }
}

export default NoEligibleAccounts;
